module.exports = __webpack_public_path__ + "img/POP-upwindow.e12d64c9.png";